import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 scroll-smooth" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemsSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <HowItWorksSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <CtaSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}